import { NgModule } from '@angular/core';
import { ActivitiesTimelineService, ActivityService, CrmCoreModule, CrmObjectService } from '@galaxy/crm/static';
import {
  ACCOUNT_SELECTOR_SERVICE_TOKEN,
  CreateOpportunityModule,
  MARKET_SELECTOR_SERVICE_TOKEN,
  OpportunityDetailsModule,
  OpportunityModule,
  OpportunitySidePanelEventsService,
  SALES_UI_OPPORTUNITY_CONFIG_TOKEN,
  UserPipelines,
  USER_PIPELINES_SERVICE_CONFIG_TOKEN,
  USER_PIPELINES_TOKEN,
} from '@vendasta/sales-ui';
import { MarketSelectorService } from '../pipeline/market-selector.service';
import { BusinessInfoService } from './business-info.service';
import { CompanyAccountService } from './company-account.service';
import { SnapshotSidepanelService } from './company-table/snapshot-sidepanel/snapshot-sidepanel.service';
import { FeatureAccessService } from './feature-access.service';
import { CrmInjectionToken, opportunityServiceConfigFactory, userPipelinesFactory } from './providers';
import { PartnerCRMSalespersonService } from './salesperson.service';
import { CrmModule } from '@galaxy/crm/dynamic';

const CRM_PROVIDERS = [
  ActivityService,
  ActivitiesTimelineService,
  CrmObjectService,
  OpportunitySidePanelEventsService,
  SnapshotSidepanelService,
  BusinessInfoService,
  CompanyAccountService,
  PartnerCRMSalespersonService,
  FeatureAccessService,
  { provide: SALES_UI_OPPORTUNITY_CONFIG_TOKEN, useFactory: opportunityServiceConfigFactory },
  { provide: USER_PIPELINES_SERVICE_CONFIG_TOKEN, useFactory: userPipelinesFactory },
  { provide: MARKET_SELECTOR_SERVICE_TOKEN, useExisting: MarketSelectorService },
  { provide: ACCOUNT_SELECTOR_SERVICE_TOKEN, useExisting: SALES_UI_OPPORTUNITY_CONFIG_TOKEN },
  { provide: USER_PIPELINES_TOKEN, useFactory: UserPipelines.getPipelines, deps: [UserPipelines] },
];

@NgModule({
  imports: [
    CrmCoreModule.forRoot(CrmInjectionToken),
    CrmModule,
    OpportunityModule,
    OpportunityDetailsModule,
    CreateOpportunityModule,
  ],
  providers: [...CRM_PROVIDERS],
})
export class PartnerCrmModule {}
